import { getCounts } from "./helper";

// Scores
export const contentScoreWeights = [
  25, // Word Count
  15, // Target Request Check
  10, // Section Length Balance
  15, // Paraghraph Length
  15, // Presence of Intro and conclusion
  20, // Content architecture
];

// Word Count Helper
export const wordCountHelper = (wordCount, nb_words, competitorResults) => {
  let wordReference;
  let competitorMaxLength = 0; // Longueur du plus grand contenu concurrent

  // Cas avec les concurrents
  if (competitorResults?.general?.content_length?.medium) {
    wordReference = competitorResults?.general?.content_length?.medium;
    // On récupère aussi la longueur du plus grand contenu concurrent
    competitorMaxLength = competitorResults?.general?.content_length?.max;

    const contentMinimumPercentage = Math.round(
      (wordCount / wordReference) * 100
    );
    const contentMaximumPercentage = Math.round(
      (wordCount / competitorMaxLength) * 100
    );

    // Cas où le contenu est trop court par rapport à la moyenne des concurrents
    if (contentMinimumPercentage < 80) {
      return {
        score: 35,
        percentage: 79,
        words: wordCount,
        nb_words: wordReference,
        competitors: competitorResults != null,
      };
    }
    // Cas où le contenu est légèrement trop court par rapport à la moyenne des concurrents
    else if (contentMinimumPercentage < 90) {
      return {
        score: 70,
        percentage: 89,
        words: wordCount,
        nb_words: wordReference,
        competitors: competitorResults != null,
      };
    }
    // Cas où le contenu est plus long que 120% du plus grand contenu concurrent (trop long)
    else if (contentMaximumPercentage > 120) {
      return {
        score: 35,
        percentage: 119,
        words: wordCount,
        nb_words: wordReference,
        competitors: competitorResults != null,
      };
    }
    // Cas où le contenu est entre 110% et 120% de la longueur du plus long concurrent
    else if (contentMaximumPercentage > 110) {
      return {
        score: 70,
        percentage: 109,
        words: wordCount,
        nb_words: wordReference,
        competitors: competitorResults != null,
      };
    }
    // Cas où tout est bon
    else {
      return {
        score: 100,
        percentage: 100,
        words: wordCount,
        nb_words: wordReference,
        competitors: competitorResults != null,
      };
    }
  } else {
    // Cas sans données concurrentielles
    wordReference = nb_words;
    const calculated_value = Math.round((wordCount / wordReference) * 100);

    if (calculated_value < 80 || calculated_value > 120) {
      return {
        score: 35,
        percentage: calculated_value,
        words: wordCount,
        nb_words: wordReference,
        competitors: false,
      };
    } else if (calculated_value < 90 || calculated_value > 110) {
      return {
        score: 70,
        percentage: calculated_value,
        words: wordCount,
        nb_words: wordReference,
        competitors: false,
      };
    } else {
      return {
        score: 100,
        percentage: calculated_value,
        words: wordCount,
        nb_words: wordReference,
        competitors: false,
      };
    }
  }
};

// Count Sentences
export const countSentences = (text) => {
  // Match sentences ending with ., ?, or !, considering abbreviations
  const sentences = text.match(/[^.!?]+[.!?]+/g);
  return sentences ? sentences.length : 0;
};

// Content length between headings
export const getContentlengthWithHeadings = (tags) => {
  let results = [];
  let lastHeader = null;
  let lastHeaderIndex = -1;

  tags.forEach((item, index) => {
    if (item.tag.startsWith("h")) {
      if (lastHeader !== null) {
        let nextHeading = tags
          .slice(index)
          .find((el) => el.tag.startsWith("h"));
        let endHeader = nextHeading ? nextHeading.tag : null;

        let sectionContent = tags.slice(lastHeaderIndex + 1, index);
        let contentLength = sectionContent.reduce(
          (sum, el) => sum + getCounts(el.content).words,
          0
        );

        results.push({ startHeader: lastHeader, endHeader, contentLength });
      }

      lastHeader = item.tag;
      lastHeaderIndex = index;
    }
  });

  if (lastHeaderIndex !== -1 && lastHeaderIndex < tags.length - 1) {
    let sectionContent = tags.slice(lastHeaderIndex + 1);
    let contentLength = sectionContent.reduce(
      (sum, el) => sum + getCounts(el.content).words,
      0
    );
    results.push({ startHeader: lastHeader, endHeader: null, contentLength });
  }
  return results;
};
